export const FACEBOOK_URL = "https://www.facebook.com/artigianidelcottoo";
export const INSTAGRAM_URL = "https://www.instagram.com/artigiani_del_cotto/";

export function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M14 9h3l.5-3H14V4.5c0-.9.3-1.5 1.6-1.5H17.6V.3C17.3.2 16.2 0 14.9 0 12.2 0 10.4 1.6 10.4 4.2V6H7.5v3h2.9v9H14V9z" />
    </svg>
  );
}

export function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function SocialLinks({ className = "" }: { className?: string }) {
  return (
    <div className={`flex shrink-0 items-center gap-0.5 sm:gap-1 ${className}`}>
      <a
        href={FACEBOOK_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Artigiani del Cotto su Facebook"
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-muted-foreground sm:h-9 sm:w-9 transition-colors hover:bg-secondary hover:text-primary"
      >
        <FacebookIcon className="h-4 w-4" />
      </a>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="Artigiani del Cotto su Instagram"
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-muted-foreground sm:h-9 sm:w-9 transition-colors hover:bg-secondary hover:text-primary"
      >
        <InstagramIcon className="h-4 w-4" />
      </a>
    </div>
  );
}
